var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_alert",
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.52,
    height: 33.661,
    viewBox: "0 0 34.52 33.661",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1126",
    "data-name": "Tracciato 1126",
    d: "M9.656,0,.335,8.494,0,21l4.705,9.9,11.963,2.761,11.639-5.182,6.212-11.635L29.421,2.6,15.662.078Z",
    transform: "translate(0 0)",
    fill: "#b8b8b8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_706",
    "data-name": "Raggruppa 706"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1127",
    "data-name": "Tracciato 1127",
    d: "M41.365,44.065H37.4L35.583,31.61l7.592,0Z",
    transform: "translate(-22.995 -25.561)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_337",
    "data-name": "Rettangolo 337",
    width: 4.226,
    height: 4.01,
    transform: "matrix(0.999, -0.045, 0.045, 0.999, 14.371, 21.667)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlert);
export default __webpack_public_path__ + "static/media/Icon_alert.ccc983fd51994bdb1c06edbbf76927c7.svg";
export { ForwardRef as ReactComponent };